export default "__VITE_ASSET__Bcir$2R7__"